import { Box, Divider } from '@factorialco/deprecated-design-system'

import { useExpensableJournalEntries } from 'modules/expenses/components/expenses/Detail/hooks/useExpensableJournalEntries'
import { Expensable } from 'modules/expenses/types/Expensable'
import { JournalEntryTab } from 'modules/finance/components/JournalsEntry/JournalEntryTab'
import { JournalDraftEntryTab } from 'modules/finance/components/JournalsEntry/JournalEntryTab/JournalDraftEntry'

interface Props {
  expensable: Expensable
}

const Accounting = ({ expensable }: Props) => {
  const { journalDraftEntry, journalEntries } = useExpensableJournalEntries({ expensable })

  return (
    <Box padding="s24" gap="s40">
      {journalDraftEntry && (
        <Box paddingTop={'s16'}>
          <JournalDraftEntryTab
            journalDraftEntry={journalDraftEntry}
            legalEntity={journalDraftEntry.legalEntity}
            currency={expensable.currency}
          />
        </Box>
      )}

      {journalEntries.length > 0 &&
        journalEntries.map(
          (journalEntry, index) =>
            journalEntry &&
            journalEntry.legalEntity && (
              <Box key={journalEntry.id} flexDirection="column" gap="s16">
                {index > 0 && <Divider />}
                <JournalEntryTab
                  journalEntry={journalEntry}
                  legalEntity={journalEntry.legalEntity}
                  currency={expensable.currency}
                />
              </Box>
            )
        )}
    </Box>
  )
}

export default Accounting
